import { apiRequest } from "@/lib/api-client"

export interface Gym {
  _id: string
  name: string
  address: string
  city: string
  country: string
  phone: string
  email: string
  workingHours?: string
  facilities?: string // Changed from string[] to string
  status: "active" | "inactive"
  createdAt: string
  updatedAt: string
}

export async function getGyms() {
  return apiRequest<Gym[]>({
    method: "GET",
    url: "/gyms",
  })
}

export async function getGym(id: string) {
  return apiRequest<Gym>({
    method: "GET",
    url: `/gyms/${id}`,
  })
}

export async function createGym(data: Partial<Gym>) {
  return apiRequest<Gym>({
    method: "POST",
    url: "/gyms",
    data,
  })
}

export async function updateGym(id: string, data: Partial<Gym>) {
  return apiRequest<Gym>({
    method: "PATCH", // Changed from PUT to PATCH
    url: `/gyms/${id}`,
    data,
  })
}

export async function deleteGym(id: string) {
  return apiRequest<{ success: boolean }>({
    method: "DELETE",
    url: `/gyms/${id}`,
  })
}
